import { Pipe, PipeTransform } from '@angular/core';
import { ShipmentShortRecord } from '../../overview/models/container';

@Pipe({
  name: 'getAllReferences',
  standalone: true
})
export class GetAllReferencesPipe implements PipeTransform {
  transform(shipments: ShipmentShortRecord[]): string {
    if (!shipments || shipments.length === 0) {
      return '';
    }

    return shipments
      .map(({ references }) => references)
      .flat()
      .join(', ');
  }
}
